export function toFixedNumber(num: number, digits: number) {
  const pow = 10 ** digits;
  return Math.round(num * pow) / pow;
}

export function inRange(number: number, start: number, end: number) {
  return number >= Math.min(start, end) && number < Math.max(start, end);
}

export function getRandomFromArray(arr: number[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
